module.exports = {
  MultipleChoice: {
    PluginName: "Multiple Choice",
    content_box_name: "Content ",
    Statement:
      "This is a Multiple Choice question with a single correct answer. You can write here the question statement",
    Question: "Question",
    Answer: "Answer",
    Feedback: "Feedback",
    FeedbackMsg:
      "Here you can provide some feedback about the answer. In order to disable this feature, turn it off in the toolbar.",
    TrueFeedbackMsg:
      '<span class="div-float-left-margin-right-8" ><img><svg id="Layer_1" data-name="Layer 1" height="25" width="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.74 14.85"><defs><style>.cls-1{fill:#31a148;}</style></defs><path class="cls-1" d="M8,19.43H7.89a1.59,1.59,0,0,1-1.29-.73,27.7,27.7,0,0,0-4.89-5.38,1.59,1.59,0,0,1,2-2.46A32.74,32.74,0,0,1,8,15.22,60.13,60.13,0,0,1,20.41,4.83a1.59,1.59,0,1,1,1.73,2.68A53,53,0,0,0,9.23,18.78,1.58,1.58,0,0,1,8,19.43Z" transform="translate(-1.13 -4.57)"/></svg></img></span>Here you can provide some feedback about the true answer. In order to disable this feature, turn it off in the toolbar.',
    FalseFeedbackMsg:
      '<span class="div-float-left-margin-right-8" ><img><svg id="Layer_2" data-name="Layer 2" height="24" width="24"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.3 20.3"><defs><style>.cls-2{fill:#e01f26;}</style></defs><path class="cls-2" d="M20,22.15a2.15,2.15,0,0,1-1.51-.62l-16-16a2.13,2.13,0,0,1,3-3L21.53,18.52A2.13,2.13,0,0,1,20,22.15Z" transform="translate(-1.85 -1.85)"/><path class="cls-2" d="M4,22.15a2.13,2.13,0,0,1-1.5-3.63l16.05-16a2.13,2.13,0,0,1,3,3l-16,16.05A2.15,2.15,0,0,1,4,22.15Z" transform="translate(-1.85 -1.85)"/></svg></img></span>Here you can provide some feedback about the false answer. In order to disable this feature, turn it off in the toolbar.',
    ShowFeedback: "Show feedback msg.",
    Number: "Number  of answers",
    ShowLettersInsteadOfNumbers: "Numbering",
    ShowLetters: "Letters",
    ShowNumbers: "Numbers",
    QuizColor: "Quiz color",
    Color: "Color",
    correctAnswerFeedback: "Correct answer",
    notCount: "This exercise does not add points",
    tryAgain: "Try Again",
    seeAnswer: "See Answer",
    selectOption: "Please Select an option",
    answerAll: "Please make sure you mark all options",
    checkAnswer: "Check Answer",
    sendAnswer: "Send Answer",
    correctStatus: "Correct!",
    wrongStatus: "Incorrect answer",
    Shuffle: "Shuffle the Options",
    WhichButtons: "Button Type",
    isMandatory: "Answer Requirement",
    CheckAnswerText: "Check Answer Button Text",
    TryAgainText: "Try Again Button Text",
    SeeAnswerText: "See Answer Button Text",
    ButtonStyle: "Button Style",
    ButtonBackground: "Button Background Color",
    ButtonTextColor: "Button Text Color",
    ButtonBorderColor: "Button Border Color",
    ButtonBorderWidth: "Button Border Width",
    ButtonBorderRadius: "Button Border Radius",
    ButtonPadding: "Button Padding",
    ButtonFontSize: "Button Font Size",
    ButtonFontWeight: "Button Font Weight",
    ButtonHoverBackground: "Button Hover Background Color",
  },
};
